// angular
import { Injectable } from '@angular/core';

// addons
import { Observable } from 'rxjs';

// service
import { ApiService } from './api.service';

// models
import {
  IBonusTradeSubmitWithFile,
  ITrade,
  ITradeComment,
  ITradeCommentSubmit,
  ITradeCreationResult,
  ITradeSlim,
  ITradeSubmitWithFile,
  ITransaction,
  TradeCommentType
} from '@shared/models';

@Injectable()
export class TradeService {
  private baseUrl = '/trades';
  private feedUrl = 'feed';

  constructor(private apiService: ApiService) {}

  getTrades(filter): Observable<ITradeSlim[]> {
    const queryParams = this.apiService.mapParams(filter);

    return this.apiService.get(this.baseUrl, queryParams);
  }

  getTrade(id: number): Observable<ITrade> {
    return this.apiService.get(`${this.baseUrl}/${id}`);
  }

  getTradeFeed(tradeId: number, feedType: TradeCommentType): Observable<ITradeComment[]> {
    const queryParams = this.apiService.mapParams({ type: feedType });

    return this.apiService.get(`${this.baseUrl}/${tradeId}/${this.feedUrl}`, queryParams);
  }

  addComment(tradeId: number, comment: ITradeCommentSubmit): Observable<void> {
    return this.apiService.post(`${this.baseUrl}/${tradeId}/${this.feedUrl}`, comment);
  }

  cancelTrade(id: number): Observable<void> {
    return this.apiService.put(`${this.baseUrl}/${id}/cancel`);
  }

  approveTrade(id: number): Observable<void> {
    return this.apiService.put(`${this.baseUrl}/${id}/approve`);
  }

  endTrade(id: number): Observable<void> {
    return this.apiService.put(`${this.baseUrl}/${id}/end`);
  }

  declineTrade(id: number): Observable<void> {
    return this.apiService.put(`${this.baseUrl}/${id}/decline`);
  }

  finalizeTrade(id: number, userIds: number[]): Observable<void> {
    return this.apiService.put(`${this.baseUrl}/${id}/finalize`, { userIds });
  }

  addTradeWithImport(trade: ITradeSubmitWithFile): Observable<ITradeCreationResult> {
    return this.apiService.post2(this.baseUrl, trade);
  }

  addBonusTradeWithImport(trade: IBonusTradeSubmitWithFile): Observable<ITradeCreationResult> {
    return this.apiService.post(`/bonus`, trade);
  }

  updateBlocksBalance(tradeId: number, numberOfBlocks: number): Observable<ITransaction> {
    return this.apiService.post(`${this.baseUrl}/${tradeId}/transaction`, { numberOfBlocks });
  }

  updateBonusBlocksBalance(tradeId: number, userId: number, numberOfCertificates: number): Observable<ITransaction> {
    return this.apiService.post(`/bonus/${tradeId}/transaction`, { userId, numberOfCertificates });
  }

  removeTrade(id: number): Observable<void> {
    return this.apiService.delete(`${this.baseUrl}/${id}`);
  }
}
